/* 
 * Fichier: assets/product-bundle-cart-integration.js
 * Intégration du bundle avec le bouton Buy Now pour aller direct au checkout
 */

(function() {
  // Protection contre le chargement multiple
  if (window.bundleCartIntegrationInitialized) return;
  window.bundleCartIntegrationInitialized = true;

  function init() {
    const bundleContainer = document.querySelector('[data-bundle-container]');
    
    if (!bundleContainer) return;

    // Attendre que les boutons de paiement dynamiques soient chargés
    setTimeout(function() {
      // Chercher le bouton "Buy it now" de Shopify (payment button)
      const paymentButtons = document.querySelectorAll('.shopify-payment-button__button');
      
      paymentButtons.forEach(function(button) {
        // Intercepter le clic sur le bouton
        button.addEventListener('click', async function(e) {
          e.preventDefault();
          e.stopPropagation();

          // Récupérer les produits du bundle avec quantité > 0
          const bundleItems = bundleContainer.querySelectorAll('[data-bundle-item]');
          const bundleProducts = [];

          bundleItems.forEach(function(item) {
            const input = item.querySelector('[data-quantity-input]');
            const productId = item.getAttribute('data-product-id');
            const quantity = parseInt(input.value) || 0;

            if (quantity > 0 && productId) {
              bundleProducts.push({
                id: productId,
                quantity: quantity
              });
            }
          });

          // Vérifier qu'il y a au moins un produit dans le bundle
          if (bundleProducts.length === 0) {
            alert('Veuillez sélectionner au moins un produit du bundle');
            return;
          }

          try {
            // Ajouter les produits du bundle au panier
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ items: bundleProducts })
            });

            if (!response.ok) {
              throw new Error('Erreur lors de l\'ajout au panier');
            }

            // Rediriger vers le checkout
            window.location.href = '/checkout';

          } catch (error) {
            console.error('Erreur:', error);
            alert('Erreur lors de l\'ajout au panier. Veuillez réessayer.');
          }
        }, true); // useCapture = true pour intercepter avant le comportement par défaut
      });

      // Alternative : intercepter aussi les autres boutons de paiement express
      const expressButtons = document.querySelectorAll('[data-testid="Checkout-button"], .dynamic-checkout__button');
      expressButtons.forEach(function(button) {
        button.addEventListener('click', async function(e) {
          e.preventDefault();
          e.stopPropagation();

          const bundleItems = bundleContainer.querySelectorAll('[data-bundle-item]');
          const bundleProducts = [];

          bundleItems.forEach(function(item) {
            const input = item.querySelector('[data-quantity-input]');
            const productId = item.getAttribute('data-product-id');
            const quantity = parseInt(input.value) || 0;

            if (quantity > 0 && productId) {
              bundleProducts.push({
                id: productId,
                quantity: quantity
              });
            }
          });

          if (bundleProducts.length === 0) {
            alert('Veuillez sélectionner au moins un produit du bundle');
            return;
          }

          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ items: bundleProducts })
            });

            window.location.href = '/checkout';
          } catch (error) {
            console.error('Erreur:', error);
            alert('Erreur lors de l\'ajout au panier. Veuillez réessayer.');
          }
        }, true);
      });

    }, 1000); // Attendre 1 seconde que les boutons soient bien chargés
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();